/** Says a thing has a place in the app before it has a screen behind it. */
export function Soon() {
  return (
    <span className="rounded-full bg-foreground/10 px-1.5 py-0.5 text-[10px] font-medium tracking-wide uppercase">
      Soon
    </span>
  );
}
